import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';

import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { ErrorInterceptor } from './_helpers/error.interceptor';

import { Globals } from './_globals/globals';

// Traductor
import { Translation } from './_languages/translations';

// import { environment } from 'src/environments/environment';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { MainShowComponent } from './main/components/main-show/main-show.component';
import { MasterShowComponent } from './main/components/master-show/master-show.component';
import { AutoOptiShowComponent } from './main/components/auto-opti-show/auto-opti-show.component';
import { DocumentShowComponent } from './main/components/document-show/document-show.component';
import { NotFoundComponent } from './main/components/not-found/not-found.component';
import { HelpCenterComponent } from './help/help-center.component';
import { AssistantMascotComponent } from './help/assistant-mascot.component';


// Módulos propios
import { UserModule } from './user/user.module';
import { CustomersModule } from './customers/customers.module';
import { AgentModule } from './agent/agent.module';
import { OptiModule } from './opti/opti.module';
import { EaselModule } from './maestros/easel/easel.module';
import { ParameterModule } from './parameter/parameter.module';
import { UserGroupModule } from './userGroup/userGroup.module';
import { TrackingModule } from './tracking/tracking.module';
import { SortableColumnModule } from './sortableColumn/sortableColumn.module';
import { CuttingTableModule } from './maestros/cutting_table/cutting_table.module';
import { BendingMachineModule } from './maestros/bending_machine/bending_machine.module';
import { LabelEditorModule } from './maestros/label_editor/label-editor.module';
import { WorkstepModule } from './maestros/workstep/workstep.module';
import { ReasonModule } from './maestros/reason/reason.module';
import { DeliveryRouteModule } from './delivery-route/delivery-route.module';

// Turomas módulos
import { FileModule } from './file/file.module';

/* NgRx */
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducer } from './state/app.reducer';
import { EffectsModule } from '@ngrx/effects';

// Para añadir un archivo de Efectos al módulo principal de la aplicación.
// import { AppEffects } from './state/app.effects';

// Servicios para componentes auxiliares
import { SortableColumnService } from './sortableColumn/sortableColumn.service';

// Importar módulo para paginación de tablas
import { NgxPaginationModule } from 'ngx-pagination';

// Importar módulo para poder copiar texto al "clipboard".
// import { ClipboardModule } from 'ngx-clipboard';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MainShowComponent,
    MasterShowComponent,
    AutoOptiShowComponent,
    DocumentShowComponent,
    NotFoundComponent,
    HelpCenterComponent,
    AssistantMascotComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    UserModule,
    UserGroupModule,
    AgentModule,
    OptiModule,
    EaselModule,
    FileModule,
    ParameterModule,
    CuttingTableModule,
    BendingMachineModule,
    LabelEditorModule,
    WorkstepModule,
    ReasonModule,
    DeliveryRouteModule,
    CustomersModule,
    TrackingModule,
    SortableColumnModule,
    NgxPaginationModule,
    // ClipboardModule,
    AppRoutingModule,
    HttpClientModule,
    // EffectsModule.forFeature([AppEffects]), // IMPORTANTE: Esta línea debe ir antes que "EffectsModule.forRoot".
    AgmCoreModule.forRoot({apiKey: 'AIzaSyAA6y9SXytOwoF9X40881Rx-8V3rtUtaU0'}),
    StoreModule.forRoot({ app: reducer }),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({
      name: 'vs-resource App Devtools',
      maxAge: 25,
      // logOnly: environment.production
    })
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    Globals,
    Translation,
    SortableColumnService
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
